<script setup lang="ts">
interface Props {
    active?: boolean
}

withDefaults(defineProps<Props>(), {
    active: false,
})
</script>

<template>
    <PureButton :primary="active" :ghost="!active" :secondary="!active">
        <slot />
    </PureButton>
</template>
